import { KeyValueProp, Question } from './Questionnaire';
import { Product } from './Product';
import { Lead } from './Lead';
import { Customer } from './Customer';

export type OperationHistoryItemType = 'START_OPERATION' |
  'PAGE_CHANGE' |
  'VIEW_RESULT_SET' |
  'VIEW_PRODUCT' |
  'VIEW_ALL_PRODUCTS' |
  'ADD_LEAD' |
  'UPDATE_LEAD' |
  'VIEW_DOCUMENT' |
  'DOWNLOAD_DOCUMENT' |
  'SEND_DOCUMENT' |
  'ADD_CUSTOMER' |
  'SELECT_CUSTOMER' |
  'UPDATE_CUSTOMER' |
  'COMPLETE_OPERATION' |
  'UPDATE_OPERATION' |
  'SUSPEND_OPERATION' |
  'CONTINUE_OPERATION' |
  'ANSWER_QUESTION' |
  'SKIP_PRODUCT_SELECTION' |
  'PRESELECT_QUESTION';

export type OperationHistoryItemTypeProp =
  OperationHistoryStartOperation
  | OperationHistoryCompleteOperation
  | OperationHistoryUpdateOperation
  | OperationHistorySuspendOperation
  | OperationHistoryContinueOperation
  | OperationHistoryPageChange
  | OperationHistoryViewResultSet
  | OperationHistoryViewProduct
  | OperationHistoryViewAllProducts
  | OperationHistoryAddLead
  | OperationHistoryUpdateLead
  | OperationHistoryViewDocument
  | OperationHistoryDownloadDocument
  | OperationHistorySendDocument
  | OperationHistoryAddCustomer
  | OperationHistorySelectCustomer
  | OperationHistoryUpdateCustomer
  | OperationHistoryAnswerQuestion
  | OperationHistorySkipProductSelection
  | OperationHistoryPreselectQuestion;

export interface OperationHistoryItemProp {
  type: OperationHistoryItemType;
  timestamp: string;
  additionalAddress?: string;
}

export interface OperationHistoryPreselectQuestion extends OperationHistoryAnswerQuestion {
}

export interface OperationHistorySkipProductSelection extends OperationHistoryAnswerQuestion {
}

export interface OperationHistoryAnswerQuestion extends OperationHistoryItemProp {
  question: OperationQuestion;
}

export interface OperationHistoryUpdateCustomer extends OperationHistoryItemProp {
  oldCustomer: Customer;
  newCustomer: Customer;
}

export interface OperationHistorySelectCustomer extends OperationHistoryAddCustomer {
}

export interface OperationHistoryAddCustomer extends OperationHistoryItemProp {
  customer: Customer;
}

export interface OperationHistorySendDocument extends OperationHistoryViewDocument {
  receiver: Customer;
}

export interface OperationHistoryDownloadDocument extends OperationHistoryViewDocument {
  //
}

export interface OperationHistoryViewDocument extends OperationHistoryItemProp {
  documentName: string;
  documentId: string;
}

export interface OperationHistoryAddLead extends OperationHistoryItemProp {
  lead: Lead;
}

export interface OperationHistoryUpdateLead extends OperationHistoryItemProp {
  lead: Lead;
}

export interface OperationHistoryViewProduct extends OperationHistoryItemProp {
  product: Product;
}

export interface OperationHistoryViewAllProducts extends OperationHistoryItemProp {
  //
}

export interface OperationHistoryViewResultSet extends OperationHistoryItemProp {
  products: string[];
}

export interface OperationHistoryStartOperation extends OperationHistoryItemProp {
}

export interface OperationHistoryCompleteOperation extends OperationHistoryItemProp {
}

export interface OperationHistoryUpdateOperation extends OperationHistoryItemProp {
}

export interface OperationHistorySuspendOperation extends OperationHistoryItemProp {
  //
}

export interface OperationHistoryContinueOperation extends OperationHistoryItemProp {
  //
}

export interface OperationHistoryPageChange extends OperationHistoryItemProp {
  pageTitle: string;
}

export type OperationHistoryItem = OperationHistoryItemTypeProp;

export interface OperationQuestion extends Question {
  value: boolean | string | KeyValueProp | null;
  answered: boolean;
}

export interface Note {
  id?: string;
  timestamp: string;
  subject: string;
  body: string;
}

export interface Operation {
  id?: string;
  userId: string;
  customerId: string;
  notes: Note[];
  concludingQuestions: OperationQuestion[];
  additionalQuestions?: { [key: string]: OperationQuestion[] };
  questions: OperationQuestion[];
  history: OperationHistoryItem[];
  summaryDocumentId?: string;
  status: string;   // -> OperationStatus
  createdAt: Date;
  updatedAt: Date;
}

export enum OperationStatus {
  CREATED = 'new',
  OPEN = 'open',
  CLOSED = 'close',
  DONE = 'done',
  WARN = 'warn',
  ERROR = 'error',
  DELETED = 'delete',
}

export interface Note {
  subject: string;
  body: string;
  timestamp: string;
}
